    (() => {
    const TEST_ID = "MM29";
    const VARIANT_ID = "V1";

    const fontAzret = 'Akkurat-Mono-_1_," sans-serif"';
    const fontCircular = 'Circular,sans-serif';

    const logInfo = (message) => {
        console.log(
        `%cAcadia%c${TEST_ID}-${VARIANT_ID}`,
        "color: white; background: rgb(0, 0, 57); font-weight: 700; padding: 2px 4px; border-radius: 2px;",
        "margin-left: 8px; color: white; background: rgb(0, 57, 57); font-weight: 700; padding: 2px 4px; border-radius: 2px;",
        message
        );
    };
    logInfo('');

    const testCondition = () => {
        let condition = (
            isMobile() &&
            getOriginalMenu() &&
            !document.querySelector('.mm6-wrapper')
        );
        return condition;
    };

    const getOriginalMenu = () => {
        let menu = false;
        const mobileMenu = document.querySelector('.new-header__mobile-menu');
        if( mobileMenu ) {
            menu = mobileMenu;
        }
        return menu;
    };

    const isMobile = () => {
        return window.matchMedia("(max-width: 749px)").matches ? true : false;
    };

    const isEventAdded = (ga4EventName) => {
        window.dataLayer = window.dataLayer || [];
        return window.dataLayer.some(item => item['ga4-event-p1-value'] !== undefined && item['ga4-event-p1-value'] === ga4EventName);
    };

    const fireEvent = (eventName = '', eventValue = '') => {
        window.dataLayer.push({
            event: "GA4event",
            "ga4-event-name": 'cro_event',
            "ga4-event-p1-name": 'event_category',
            "ga4-event-p1-value": eventName,
            "ga4-event-p2-name": 'event_label',
            "ga4-event-p2-value": eventValue,
        });
    };

    const addCSS = () => {
        let style = document.createElement('style');
        style.id  = 'acadia-custom-styles-mm6';
        let styleCSS = `
            .mm6-hidden {
                display: none !important;
            }

            body.mm6-body-scroll-lock {
                overflow: hidden !important;
            }

            .mm6-menu--original .header__menu__links,
            .mm6-menu--original .header__megamenu-list {
                display: none;
            }

            .mm6-grid {
                list-style: none;
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                gap: 32px;
                row-gap: 15px;
            }
            .mm6-grid-item {
                width: 100%;
            }
            .mm6-grid-item__link {
                text-decoration: none;
                display: flex;
                flex-direction: row;
                gap: 15px;
            }
            .mm6-grid-item__image {
                width: 105px;
                height: 105px;
                object-fit: cover;
                border: 2px solid #000;
                border-radius: 2px;
            }
            .mm6-grid-item-content {
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                padding: 5px 0;
                gap: 10px;
            }
            .mm6-grid-item-heading {
                display: flex;
                justify-content: left;
                align-items: center;
                gap: 15px;
            }
            .mm6-grid-item__title {
                color: #000;
                text-align: center;
                font-family: ${fontCircular};
                font-size: 20px;
                font-style: italic;
                font-weight: 600;
                line-height: normal;
                letter-spacing: -0.6px;
                margin-bottom: 0px;
            }
            .mm6-grid-item__tag {
                color: #000;
                text-align: center;
                font-family: ${fontAzret};
                font-size: 10px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                border-radius: 5px;
                padding: 3px 5px;
            }
            .mm6-grid-item__tag--green {
                background-image: url(//magicmind.com/cdn/shop/files/Frame_47.png?v=1762428239&width=100);
            }
            .mm6-grid-item__tag--orange {
                background-image: url(//magicmind.com/cdn/shop/files/Frame_61.png?v=1762428239&width=100);
            }
            .mm6-grid-item__tag--blue {
                background-image: url(//magicmind.com/cdn/shop/files/Frame_62.png?v=1762428239&width=100);
            }
            .mm6-grid-item__tag--purple {
                background-image: url("https://assets.replocdn.com/projects/8986006d-3172-496e-baa5-e50015814552/1fc5040d-f87c-49c3-9238-214a95ddc074");
            }
            .mm6-grid-item-text {
                color: #000;
                font-family: ${fontCircular};
                font-size: 14px;
                font-style: normal;
                font-weight: 450;
                line-height: normal;
            }

            .mm6-links {
                margin: 0 auto;
                margin-top: 30px;
                display: flex;
                justify-content: center;
                width: 100%;
            }
.mm6-grid-item__link:active {
text-decoration:underline;
}

.mm6-links-section a:active {
text-decoration:underline;
}
            .mm6-links-section {
                width: 50%;
                border-top: 2px solid #000;    
                border-bottom: 2px solid #000;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 20px 0;
            }
            .mm6-links-left {
                border-right: 2px solid #000;    
            }
            .mm6-links-section a {
                padding: 10px 0;
            }

            .mm6-review {
                margin-top: 20px;
                margin-bottom: 25px;
                background-image: url(https://magicmind.com/cdn/shop/files/Rectangle_2758_887d278c-ba56-45db-b2fb-29d42b531797.webp?v=1756293032);
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                border-radius: 2px;
                border: 2px solid #000;
                padding: 20px 32px;
                text-align: center;
            }
            .mm6-review svg {
                margin-bottom: 8px;
            }
            .mm6-reviews__title {
                color: #000;
                text-align: center;
                font-family: ${fontCircular};
                font-size: 20px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
            }
            .mm6-reviews__text {
                color: #000;
                text-align: center;
                font-family: ${fontCircular};
                font-size: 18px;
                font-style: italic;
                font-weight: 300;
                line-height: normal;
                margin: 15px auto 20px;
            }
            .mm6-reviews__author {
                display: flex;
                gap: 10px;
                justify-content: center;
                align-items: center;
                margin-top: 0px;
            }
            .mm6-reviews__author p {
                margin-bottom: 0;
                color: #000;
                text-align: center;
                font-family: ${fontCircular};
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
            }
            .mm6-reviews__author span {
                color: #FFF;
                text-align: center;
                font-family: ${fontCircular};
                font-size: 12px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                background: #000;
                padding: 3px 5px;
                border-radius: 2px;
            }
        `;
        style.textContent = styleCSS;
        if( !document.querySelector('#acadia-custom-styles-mm6') ) document.head.appendChild(style);
    };

    const createNewMenu = () => {
        addCSS();

        const originalMenu = getOriginalMenu();
        if( !originalMenu ) return;

        originalMenu.classList.add('mm6-menu--original');

        const newMenu = document.createElement('div');
        newMenu.classList.add('mm6-wrapper');
        newMenu.innerHTML = `
            <div class="mm6-container">
<p style="
    font-size: 23px;
">Products</p>
                <ul class="mm6-grid">
                    <li class="mm6-grid-item">
                        <a class="mm6-grid-item__link" href="https://magicmind.com/products/mental-performance-shot-original">
                            <img class="mm6-grid-item__image" src="//magicmind.com/cdn/shop/files/Original_ed5f7c6a-d622-41b1-a89a-955c7708f2be.webp?v=1758100071&amp;width=400" loading="lazy" width="400" height="400" alt="">
                            <div class="mm6-grid-item-content">
                                <div class="mm6-grid-item-heading">
                                    <p class="mm6-grid-item__title">Original</p>
                                    <p class="mm6-grid-item__tag mm6-grid-item__tag--orange">55mg caffeine</p>
                                </div>
                                <div class="mm6-grid-item-text">The world’s first mental performance shot for a sharper mind and sustained energy.</div>
                            </div>
                        </a>
                    </li>
                    <li class="mm6-grid-item">
                        <a class="mm6-grid-item__link" href="https://magicmind.com/products/mental-performance-shot-maxx">
                            <img class="mm6-grid-item__image" src="//magicmind.com/cdn/shop/files/Maxx_ec88799a-2967-41b1-a418-a77282e3e0d5.webp?v=1758100085&amp;width=400" loading="lazy" width="400" height="400" alt="">
                            <div class="mm6-grid-item-content">
                                <div class="mm6-grid-item-heading">
                                    <p class="mm6-grid-item__title">MAXX</p>
                                    <p class="mm6-grid-item__tag mm6-grid-item__tag--blue">165mg caffeine</p>
                                </div>
                                <div class="mm6-grid-item-text">Unlock 6+ hours of sustained mental performance with time-release caffeine.</div>
                            </div>
                        </a>
                    </li>
                    <li class="mm6-grid-item">
                        <a class="mm6-grid-item__link" href="https://magicmind.com/products/mental-performance-shot-free">
                            <img class="mm6-grid-item__image" src="//magicmind.com/cdn/shop/files/Free_85d6ffde-8a99-4358-848b-6a01fc322853.webp?v=1758100091&amp;width=400" loading="lazy" width="400" height="400" alt="">
                            <div class="mm6-grid-item-content">
                                <div class="mm6-grid-item-heading">
                                    <p class="mm6-grid-item__title">FREE</p>
                                    <p class="mm6-grid-item__tag mm6-grid-item__tag--green">0mg caffeine</p>
                                </div>
                                <div class="mm6-grid-item-text">Experience a sharper mind and sustained energy at any time of day.</div>
                            </div>
                        </a>
                    </li>
                    <li class="mm6-grid-item">
                        <a class="mm6-grid-item__link" href="https://magicmind.com/products/magic-mind-welcome-sleep-melatonin?selling_plan=4982669446&variant=43950678442118">
                            <img class="mm6-grid-item__image" src="//magicmind.com/cdn/shop/files/Sleep.webp?v=1758100096&amp;width=400" loading="lazy" width="400" height="400" alt="">
                            <div class="mm6-grid-item-content">
                                <div class="mm6-grid-item-heading">
                                    <p class="mm6-grid-item__title">Sleep</p>
                                    <p class="mm6-grid-item__tag mm6-grid-item__tag--purple">rise brighter</p>
                                </div>
                                <div class="mm6-grid-item-text">Fall asleep faster, stay asleep longer, and wake up feeling energized.</div>
                            </div>
                        </a>
                    </li>
                </ul>

                <div class="mm6-links">
                    <div class="mm6-links-section mm6-links-left">
                        <a href="https://magicmind.com/blogs/news/science-backed-solutions-for-better-productivity-the-magic-mind%E2%93%A1-approach">Science</a>
                        <a href="https://magicmind.com/pages/reviews">Reviews</a>
                    </div>
                    <div class="mm6-links-section mm6-links-right">
                        <a href="https://magicmind.com/blogs/news">Blog</a>
                        <a href="https://magicmind.com/pages/contact">Contact</a>
                    </div>
                </div>

                <div class="mm6-review">
                    <svg xmlns="http://www.w3.org/2000/svg" width="99" height="15" viewBox="0 0 99 15" fill="none">
                        <path d="M7.82313 0.17098C7.91714 -0.0569933 8.24851 -0.0569933 8.34251 0.17098L10.3334 4.99923C10.3734 5.09631 10.4669 5.16251 10.5741 5.16958L15.9043 5.52157C16.156 5.53819 16.2584 5.84512 16.0648 6.00263L11.965 9.33864C11.8826 9.40572 11.8469 9.51283 11.8731 9.61428L13.1765 14.6601C13.238 14.8983 12.9699 15.088 12.7563 14.9574L8.23162 12.1909C8.14064 12.1353 8.025 12.1353 7.93403 12.1909L3.40937 14.9574C3.19573 15.088 2.92764 14.8983 2.98919 14.6601L4.29258 9.61428C4.31879 9.51283 4.28305 9.40572 4.20062 9.33864L0.100833 6.00263C-0.0927448 5.84512 0.00965623 5.53819 0.26133 5.52157L5.59153 5.16958C5.6987 5.16251 5.79226 5.09631 5.83229 4.99923L7.82313 0.17098Z" fill="black"/>
                        <path d="M28.5317 0.17098C28.6257 -0.0569933 28.9571 -0.0569933 29.0511 0.17098L31.042 4.99923C31.082 5.09631 31.1755 5.16251 31.2827 5.16958L36.6129 5.52157C36.8646 5.53819 36.967 5.84512 36.7734 6.00263L32.6736 9.33864C32.5912 9.40572 32.5555 9.51283 32.5817 9.61428L33.8851 14.6601C33.9466 14.8983 33.6785 15.088 33.4649 14.9574L28.9402 12.1909C28.8492 12.1353 28.7336 12.1353 28.6426 12.1909L24.118 14.9574C23.9043 15.088 23.6362 14.8983 23.6978 14.6601L25.0012 9.61428C25.0274 9.51283 24.9916 9.40572 24.9092 9.33864L20.8094 6.00263C20.6158 5.84512 20.7182 5.53819 20.9699 5.52157L26.3001 5.16958C26.4073 5.16251 26.5008 5.09631 26.5409 4.99923L28.5317 0.17098Z" fill="black"/>
                        <path d="M49.2403 0.17098C49.3343 -0.0569933 49.6657 -0.0569933 49.7597 0.17098L51.7505 4.99923C51.7906 5.09631 51.8841 5.16251 51.9913 5.16958L57.3215 5.52157C57.5732 5.53819 57.6756 5.84512 57.482 6.00263L53.3822 9.33864C53.2998 9.40572 53.264 9.51283 53.2902 9.61428L54.5936 14.6601C54.6552 14.8983 54.3871 15.088 54.1735 14.9574L49.6488 12.1909C49.5578 12.1353 49.4422 12.1353 49.3512 12.1909L44.8265 14.9574C44.6129 15.088 44.3448 14.8983 44.4064 14.6601L45.7098 9.61428C45.736 9.51283 45.7002 9.40572 45.6178 9.33864L41.518 6.00263C41.3244 5.84512 41.4268 5.53819 41.6785 5.52157L47.0087 5.16958C47.1159 5.16251 47.2094 5.09631 47.2495 4.99923L49.2403 0.17098Z" fill="black"/>
                        <path d="M69.9489 0.17098C70.0429 -0.0569933 70.3743 -0.0569933 70.4683 0.17098L72.4591 4.99923C72.4992 5.09631 72.5927 5.16251 72.6999 5.16958L78.0301 5.52157C78.2818 5.53819 78.3842 5.84512 78.1906 6.00263L74.0908 9.33864C74.0084 9.40572 73.9726 9.51283 73.9988 9.61428L75.3022 14.6601C75.3638 14.8983 75.0957 15.088 74.882 14.9574L70.3574 12.1909C70.2664 12.1353 70.1508 12.1353 70.0598 12.1909L65.5351 14.9574C65.3215 15.088 65.0534 14.8983 65.115 14.6601L66.4184 9.61428C66.4446 9.51283 66.4088 9.40572 66.3264 9.33864L62.2266 6.00263C62.033 5.84512 62.1354 5.53819 62.3871 5.52157L67.7173 5.16958C67.8245 5.16251 67.918 5.09631 67.958 4.99923L69.9489 0.17098Z" fill="black"/>
                        <path d="M90.6575 0.17098C90.7515 -0.0569933 91.0829 -0.0569933 91.1769 0.17098L93.1677 4.99923C93.2077 5.09631 93.3013 5.16251 93.4085 5.16958L98.7387 5.52157C98.9903 5.53819 99.0927 5.84512 98.8992 6.00263L94.7994 9.33864C94.7169 9.40572 94.6812 9.51283 94.7074 9.61428L96.0108 14.6601C96.0724 14.8983 95.8043 15.088 95.5906 14.9574L91.066 12.1909C90.975 12.1353 90.8594 12.1353 90.7684 12.1909L86.2437 14.9574C86.0301 15.088 85.762 14.8983 85.8235 14.6601L87.1269 9.61428C87.1531 9.51283 87.1174 9.40572 87.035 9.33864L82.9352 6.00263C82.7416 5.84512 82.844 5.53819 83.0957 5.52157L88.4259 5.16958C88.5331 5.16251 88.6266 5.09631 88.6666 4.99923L90.6575 0.17098Z" fill="black"/>
                    </svg>
                    <p class="mm6-reviews__title">Keeps Me Focused and Locked In</p>
                    <p class="mm6-reviews__text">This stuff works! I recommend it to anyone who needs help with staying focused and locked in. </p>
                    <div class="mm6-reviews__author">
                        <p>Arinn S.</p>
                        <span>Verified Buyer</span>
                    </div>
                </div>
            </div>
        `;
        if( !document.querySelector('.mm6-wrapper') ) {
            originalMenu.insertAdjacentElement('beforeend', newMenu);
            setTimeout(() => {
                configure();
            }, 0);
        }
    };

    const configure = () => {
        const gridLinks = document.querySelectorAll('.mm6-grid-item__link');
     //    gridLinks.forEach( link => {
    //         if( 
    //             link && 
    //             link.getAttribute('mm6-event-listener') !== 'true'
    //         ) {
    //             link.setAttribute('mm6-event-listener', true);
    //             link.addEventListener('click', () => {
    //                 //fireEvent('MM6_NavEngagement', link.querySelector('.mm6-grid-item__title').textContent.trim() );
    //             });
    //         }
    //     });

    //     const otherLinks = document.querySelectorAll('.mm6-links-section a');
    //     otherLinks.forEach( link => {
    //         if( 
    //             link && 
    //             link.getAttribute('mm6-event-listener') !== 'true'
    //         ) {
    //             link.setAttribute('mm6-event-listener', true);
    //             link.addEventListener('click', () => {
    //                 //fireEvent('MM6_NavEngagement', link.textContent.trim() );
    //             });
    //         }
    //     });

        // Nav OPEN
        const navButton = document.querySelector('.header__mob-btn .hamburger-wrapper');
        const observer = new MutationObserver( () => {
            if( navButton.classList.contains('active') ) {
                if( !isEventAdded('MM6_NavView') ) {
                    // observer.disconnect();
                    fireEvent('MM6_NavView');
                }
                document.body.classList.add('mm6-body-scroll-lock');
            } else {
                document.body.classList.remove('mm6-body-scroll-lock');
            }
        });
        const config = {
            attributes: true,
            attributesFilter: ['class'],
        };
        if( navButton && navButton.getAttribute('mm6-observer') !== 'true' ) {
            navButton.setAttribute('mm6-observer', true);
            observer.observe(navButton, config);
        }
    };

    const main = () => {
        let domCheck;
        const doDomCheck = () => {
            let selectorsToCheck = [
                'body',
                '.header__mob-btn .hamburger-wrapper'
            ];
 
            let performTest = true;
            selectorsToCheck.forEach( singleSelector => {
                if( ! document.querySelector(singleSelector) ) {
                    performTest = false;
                }
            });

            if ( performTest ) {
                clearInterval(domCheck);

                if( 
                    testCondition()
                ) {
                    createNewMenu();
                }
                
                const observer = new MutationObserver( () => {
                    if (
                        testCondition()
                    ) {
                        createNewMenu();
                    }
                });
                const config = {
                    subtree: true,
                    childList: true
                };
                observer.observe(document, config);
            }
        };
        domCheck = setInterval(doDomCheck, 200);
    };
    main();
})();

(function () {
  function waitForElm(selector) {
    return new Promise((resolve) => {
      const existingElement = document.querySelector(selector);
      if (existingElement) {
        return resolve(existingElement);
      }
      const observer = new MutationObserver((mutations) => {
        const foundElement = document.querySelector(selector);
        if (foundElement) {
          observer.disconnect();
          resolve(foundElement);
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }
    waitForElm('.header__logo a').then(() => {
    setTimeout(() => {
      document.querySelectorAll('.header__logo a')
      .forEach((button) => {
        button.addEventListener("click", () => {
            window.dataLayer.push({
              event: "GA4event",
              "ga4-event-name": 'cro_event',
              "ga4-event-p1-name": 'event_category',
              "ga4-event-p1-value": 'MM6_NavLogo',
              "ga4-event-p2-name": 'event_label',
              "ga4-event-p2-value": 'Logo',
            });
        });
      });
    }, 300);
  });
  waitForElm('.mm6-grid-item__link').then(() => {
    setTimeout(() => {
      document.querySelectorAll('.mm6-grid-item__link')
      .forEach((button) => {
        button.addEventListener("click", () => {
            window.dataLayer.push({
              event: "GA4event",
              "ga4-event-name": 'cro_event',
              "ga4-event-p1-name": 'event_category',
              "ga4-event-p1-value": 'MM6_NavEngagement',
              "ga4-event-p2-name": 'event_label',
              "ga4-event-p2-value": button.querySelector('.mm6-grid-item__title').textContent.trim(),
            });
        });
      });
    }, 300);
  });
    waitForElm('.mm6-links-section').then(() => {
    setTimeout(() => {
      document.querySelectorAll('.mm6-links-section a')
      .forEach((button) => {
        button.addEventListener("click", () => {
            window.dataLayer.push({
              event: "GA4event",
              "ga4-event-name": 'cro_event',
              "ga4-event-p1-name": 'event_category',
              "ga4-event-p1-value": 'MM6_NavEngagement',
              "ga4-event-p2-name": 'event_label',
              "ga4-event-p2-value": button.innerText,
            });
        });
      });
    }, 300);
  });
})();
